<template>
  <v-container class="pa-0 ma-0">
    <v-row justify="center">
      <v-col :cols="12" :sm="8">
        <h1>{{ $t('content.careerday.title') }}</h1>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col :cols="12" :sm="8">
        <p v-html="$t('content.careerday.intro')"></p>
        <table>
          <tr>
            <td v-html="$t('content.careerday.place.label')"></td>
            <td v-html="$t('content.careerday.place.value')"></td>
          </tr>
          <tr>
            <td v-html="$t('content.careerday.duration.label')"></td>
            <td v-html="$t('content.careerday.duration.value')"></td>
          </tr>
          <tr>
            <td v-html="$t('content.careerday.price.label')" style="padding-right: 16px;"></td>
            <td v-html="$t('content.careerday.price.value')"></td>
          </tr>
        </table>
        <p class="mt-4" v-html="$t('content.careerday.additional')"></p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col :cols="12" :sm="8">
        <img
          src="/static/careerday/2020-08-27-careerday-losone.jpg"
          alt="Careerday"
          style="width: 100%; height: auto;"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col :cols="12" :sm="8">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2763.0901631356946!2d8.767082616493097!3d46.16886087911562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4785c8173fdfa2ad%3A0x7ddaf290938eba8c!2sALBERGO%20LOSONE!5e0!3m2!1sde!2sch!4v1592395671970!5m2!1sde!2sch" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CareerDay',
};
</script>
